// extracted by mini-css-extract-plugin
export default {"input":"NumberInputWithDecimals_input__iXG2s","unit":"NumberInputWithDecimals_unit__nkVtN"};